<template>
    <div class="home">
        <AmountSection />
    </div>
</template>

<script>
// @ is an alias to /src
// import OrderSection from "@/components/OrderSection.vue";
import AmountSection from "../components/AmountSection.vue";

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "home",
    components: {
        AmountSection,
    },
};
</script>
